(() => {
  const config = document.getElementById('mhl-novelty-config');
  if (!config || !window.MhlNoveltyCart) return;
  const initial = JSON.parse(config.textContent);
  if (!initial.endpoint) return;
  const nativeFetch = window.fetch.bind(window); let busy = 0; let lastState = { now: Date.now(), giftIds: [], campaigns: [] }; let errorBox;
  const root = window.Shopify?.routes?.root || '/';
  function report(error) {
    if (!errorBox) { errorBox = document.createElement('div'); errorBox.className = 'mhl-novelty-error'; errorBox.setAttribute('role', 'alert'); document.body.append(errorBox); }
    errorBox.textContent = error.message || 'カートを確認できませんでした。再読み込みしてください。'; errorBox.hidden = false;
  }
  async function state() {
    const response = await nativeFetch(initial.endpoint.replace(/\/$/, '') + '/v1/storefront', { cache: 'no-store', credentials: 'omit', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('ギフト設定を確認できませんでした。時間をおいて再度お試しください。');
    const value = await response.json();
    if (value.version !== 1 || !Array.isArray(value.campaigns) || !Array.isArray(value.giftIds) || !Number.isFinite(value.now)) throw new Error('ギフト設定を取得できませんでした。');
    const ids = new Set(value.giftIds.map(String));
    if (value.giftIds.some(id => !/^[1-9]\d*$/.test(String(id)))) throw new Error('ギフト設定が不正です。');
    for (const c of value.campaigns) {
      if (!ids.has(String(c.giftId)) || !Number.isSafeInteger(c.quantity) || c.quantity < 1 || !Number.isSafeInteger(c.available) || !Number.isSafeInteger(c.cap) || c.cap < 1 || !Number.isFinite(c.start) || !Number.isFinite(c.end) || !['all', 'variants'].includes(c.target?.kind) || !Array.isArray(c.target?.variantIds)) throw new Error('ギフト設定が不正です。');
    }
    if (!initial.enabled) value.campaigns = [];
    lastState = value; decorate(); return value;
  }
  function decorate() {
    const active = lastState.campaigns.filter(c => c.enabled && lastState.now >= c.start && lastState.now < c.end && c.available > 0);
    const ids = new Set(lastState.giftIds.map(String));
    const period = c => {
      const format = n => new Intl.DateTimeFormat('ja-JP', { timeZone: 'Asia/Tokyo', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(n));
      return format(c.start) + ' 〜 ' + format(c.end - 1) + '（日本時間）';
    };
    document.querySelectorAll('[data-mhl-novelty-notice]').forEach(el => {
      const variants = JSON.parse(el.dataset.productVariants || '[]').map(String);
      const relevant = active.filter(c => variants.some(id => !ids.has(id) && (c.target.kind === 'all' || c.target.variantIds.map(String).includes(id))));
      const signature = JSON.stringify(relevant.map(c => [c.id, c.revision]));
      el.hidden = !relevant.length;
      if (el.dataset.rendered === signature) return;
      el.dataset.rendered = signature;
      el.replaceChildren();
      for (const c of relevant) {
        const block = document.createElement('div'); block.className = 'mhl-novelty__campaign';
        for (const [kind, text] of [['title', c.notice.heading], ['period', period(c)], ['text', c.notice.body], ['note', c.notice.note]]) {
          if (!text) continue;
          const p = document.createElement('p'); p.className = 'mhl-novelty__' + kind; p.textContent = text; block.append(p);
        }
        el.append(block);
      }
    });
    document.querySelectorAll('[data-novelty-variant]').forEach(row => {
      const gift = ids.has(row.dataset.noveltyVariant);
      row.classList.toggle('mhl-novelty-cart__gift', gift);
      row.querySelectorAll('input[name="updates[]"]').forEach(input => { input.readOnly = gift; if (gift) input.setAttribute('aria-label', 'ギフト数量（自動調整）'); });
    });
  }
  const controller = new window.MhlNoveltyCart({ fetcher: nativeFetch, state, rootPath: root });
  const withBusy = async fn => { busy++; try { const result = await fn(); if (errorBox) errorBox.hidden = true; return result; } finally { busy--; } };
  window.MhlNovelty = { fetch: (url, options) => withBusy(() => controller.fetch(url, options)).then(async response => { const data = await response.clone().json(); if (data.noveltyError) report(new Error(data.noveltyError)); return response; }).catch(e => { report(e); throw e; }) };
  const cartNote = form => (form?.elements?.namedItem('note') || document.querySelector('cart-note [name="note"]'))?.value;
  function cartQuantities(form) {
    const updates = {};
    for (const input of form?.elements || []) {
      if (input.name !== 'updates[]') continue;
      const row = input.closest('[data-novelty-key]');
      if (!row || lastState.giftIds.map(String).includes(row.dataset.noveltyVariant)) continue;
      if (input.value.trim() === '') throw new Error('商品の数量を確認してください。');
      const quantity = Number(input.value);
      if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('商品の数量を確認してください。');
      updates[row.dataset.noveltyKey] = quantity;
    }
    return updates;
  }
  // Capture checkout before navigation; no checkout while quantity reconciliation is incomplete.
  document.addEventListener('submit', event => {
    const submitter = event.submitter; if (!submitter?.matches('[name="checkout"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    withBusy(() => controller.checkout(cartNote(event.target), cartQuantities(event.target))).then(() => { location.assign(root + 'checkout'); }).catch(report);
  }, true);
  document.addEventListener('click', event => {
    const checkout = event.target.closest('a[href]');
    if (checkout && /\/checkout(?:[/?#]|$)/.test(checkout.getAttribute('href'))) { event.preventDefault(); event.stopImmediatePropagation(); withBusy(() => controller.checkout(cartNote(), cartQuantities(checkout.closest('form')))).then(() => { location.assign(checkout.href); }).catch(report); return; }
    if (busy && event.target.closest('cart-remove-button, cart-items .quantity__button, cart-drawer-items .quantity__button')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  let timer;
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(decorate, 30); });
  observer.observe(document.body, { childList: true, subtree: true });
  async function refreshCartChrome() {
    const ids = ['cart-icon-bubble', 'cart-notification-button', 'cart-notification-product'].filter(id => document.getElementById(id));
    if (!ids.length) return;
    const response = await nativeFetch(root + '?sections=' + ids.join(','), { cache: 'no-store' });
    if (!response.ok) throw new Error('カート表示を更新できませんでした。再読み込みしてください。');
    const sections = await response.json();
    for (const id of ids) {
      if (typeof sections[id] !== 'string') throw new Error('カート表示を更新できませんでした。再読み込みしてください。');
      const doc = new DOMParser().parseFromString(sections[id], 'text/html');
      const target = document.getElementById(id);
      if (id === 'cart-notification-product') {
        const notification = document.querySelector('cart-notification');
        const item = doc.getElementById('cart-notification-product-' + notification?.cartItemKey);
        if (item) target.innerHTML = item.innerHTML;
        else { target.innerHTML = ''; notification?.close(); }
      } else {
        const section = doc.querySelector('.shopify-section');
        if (!section) throw new Error('カート表示を更新できませんでした。再読み込みしてください。');
        target.innerHTML = section.innerHTML;
      }
    }
  }
  function refresh() {
    // Keep the rendered count and cart mutations in the same serialized operation.
    withBusy(() => controller.enqueue(async () => {
      const cart = await controller.synchronize();
      await refreshCartChrome();
      decorate();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'novelty', cartData: cart });
    })).catch(report);
  }
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
  // Covers period boundaries on a page kept open overnight.
  setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 60000);
  decorate();
})();
